import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "@reach/router";
import { AppBar, Badge, Box, CssBaseline, IconButton, Menu, MenuItem, Popover, Toolbar, Typography } from "@mui/material";
import { config } from "config";
import { DehazeRounded } from "@mui/icons-material";
import 'style/layout.scss';
import { WorkflowNavBar } from "components/workflow/workflowNavBar";


const isActive = ({ isCurrent }: any) => {
    return isCurrent
        ? { className: "active nav-link" }
        : { className: "nav-link" };
};
// `getProps` Calls up to you to get props for the underlying anchor element.
// Useful for styling the anchor as active.
const ExactNavLink = (props: any) => <Link getProps={isActive} {...props} />;

function NavBar({ userName }: any) {
    const [auth, setAuth] = React.useState(true);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleChange = (event: any) => {
        setAuth(event.target.checked);
    };

    const handleMenu = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    var appEnv = (
        <></>
    );
    if (config.REACT_APP_ENV !== "prod") {
        appEnv = (
            <>
                &nbsp;({config.REACT_APP_ENV})
            </>
        );
    }

    return (
        <div className="navbar">
            <Toolbar>
                <span className="navbarSpan">
                    {config.REACT_APP_NAME}
                    {appEnv}
                </span>
                <Box sx={{ flexGrow: 1 }} />
                <span className="navbarSpan">
                    {userName}
                </span>
                <WorkflowNavBar />
                <IconButton
                    onClick={handleMenu}>
                    <DehazeRounded />
                </IconButton>
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    open={open}
                    onClose={handleClose}
                >
                    <MenuItem>Test</MenuItem>
                    <MenuItem>Test 2</MenuItem>
                </Menu>
            </Toolbar>
        </div>

    );
}

const mapStateToProps = (state: any) => {
    return {
        userName: state.authentReducer.name,
    };
};

export default connect(mapStateToProps)(NavBar);
